import * as React from "react"
import { Link } from "gatsby"

import { FaLinkedinIn } from "@react-icons/all-files/fa/FaLinkedinIn";
import { FaFacebookSquare } from "@react-icons/all-files/fa/FaFacebookSquare";

const Footer = ({facebook, linkedin}) => (
    <footer className="mt-10 p-6 bg-lighter md:px-20 lg:p-4 bottom-0">
        <div className="flex wrap flex-col w-full lg:flex-row lg:justify-center items-baseline">
            <Link to="/contact-us" className="footer-text footer-hover"> Contact Us</Link>
            <Link to="/contact-us" className="footer-text footer-hover"> Submit Job Vacancy</Link>
            <Link to="/contact-us" className="footer-text footer-hover"> Submit CV</Link><br />
            <Link to="/disclaimers" className="footer-text footer-hover"> Disclaimers </Link>
            <span className="footer-text">© {new Date().getFullYear()}{` `}Knight Recruitment</span><br />
            <span className="footer-text">
                Find us on &nbsp;&nbsp;
                <a href={linkedin} rel="noreferrer" target="_blank" className="footer-hover">
                    <FaLinkedinIn className="inline text-2xl mb-2" />
                </a>
                &nbsp;&nbsp;
                <a href={facebook} rel="noreferrer" target="_blank" className="footer-hover">
                    <FaFacebookSquare className="inline text-2xl mb-2" />
                </a>
            </span>
        </div>
  </footer>
)


export default Footer
